import type { PortalSiteMobileAppDto } from '@supply-mover-2-0/shared';
import { useMemo } from 'react';
import {
	detectStorePlatform,
	isInsideNativeApp,
	type StorePlatform,
} from '../lib/mobileApp';
import { usePortalSiteStore } from '../stores/portalSiteStore';

export interface MobileAppPromotionModel {
	app: PortalSiteMobileAppDto;
	/** The store name, for "Get the Capital Trading app". */
	brandName: string;
	platform: StorePlatform;
	/**
	 * The store link for this phone, or null on a computer or when the app is
	 * not in this phone's store.
	 */
	phoneStoreUrl: string | null;
}

/**
 * PD-16558 — the storefront's app to promote, or null when there is nothing
 * to promote: the portal site links no store, or this is already the app.
 */
export function useMobileAppPromotion(): MobileAppPromotionModel | null {
	const app = usePortalSiteStore((s) => s.site?.mobileApp ?? null);
	const brandName = usePortalSiteStore((s) => s.site?.displayName ?? '');

	return useMemo(() => {
		if (app == null || isInsideNativeApp()) {
			return null;
		}
		const platform = detectStorePlatform();
		const phoneStoreUrl =
			platform === 'ios'
				? app.appStoreUrl
				: platform === 'android'
					? app.googlePlayUrl
					: null;
		return { app, brandName, platform, phoneStoreUrl };
	}, [app, brandName]);
}
